import React from "react";
import validZipcode from "helpers/validZipCode";
import { FilterInput } from "components/FilterInput";

export function FilterZipInput({ dataTestId = "filter-zip-input", ...rest }) {
    const isValidInput = (input) => {
        return input.length > 0 && validZipcode(input);
    };

    return (
        <FilterInput
            errorText="Voer een geldige postcode in"
            isValidInput={isValidInput}
            dataTestId={dataTestId}
            autoComplete="do-not-autofill"
            {...rest}
        />
    );
}
